"use client";

import { type ReactNode, createContext, useContext } from "react";

type Context = {
  startAction: (action: () => Promise<void>) => Promise<void>;
};

const context = createContext<Context>({
  startAction: () => Promise.resolve(),
});

export function useBackgroundActionContext() {
  return useContext(context);
}

export function BackgroundActionContextProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const startAction = async (action: () => Promise<void>) => {
    return await new Promise<void>((resolve) => {
      setTimeout(() => {
        action();

        resolve();
      }, 100);
    });
  };

  return (
    <context.Provider value={{ startAction }}>{children}</context.Provider>
  );
}
